import { render, staticRenderFns } from "./ListItemRoute.vue?vue&type=template&id=a63b37ba&scoped=true&"
import script from "./ListItemRoute.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemRoute.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ListItemRoute.vue?vue&type=style&index=0&id=a63b37ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63b37ba",
  null
  
)

export default component.exports